export const BLEED = 12;

// Angular cyber-HUD frame: a chamfered octagon outline with a faint inner
// parallel line, segmented tick marks above/below the centre, and rivets near
// the corners. Purple, with a soft glow stroke underneath the crisp line.
export default function PurpleHudFrame({ w, h }) {
  const W = w + BLEED * 2;
  const H = h + BLEED * 2;
  const x = BLEED;
  const y = BLEED;
  const x2 = x + w;
  const y2 = y + h;
  const c = 16; // chamfer size

  const oct = `M ${x + c} ${y} L ${x2 - c} ${y} L ${x2} ${y + c} L ${x2} ${y2 - c} L ${x2 - c} ${y2} L ${x + c} ${y2} L ${x} ${y2 - c} L ${x} ${y + c} Z`;
  const i = 4;
  const ic = c - 2;
  const ax = x + i;
  const ay = y + i;
  const bx = x2 - i;
  const by = y2 - i;
  const octIn = `M ${ax + ic} ${ay} L ${bx - ic} ${ay} L ${bx} ${ay + ic} L ${bx} ${by - ic} L ${bx - ic} ${by} L ${ax + ic} ${by} L ${ax} ${by - ic} L ${ax} ${ay + ic} Z`;

  const glow = '#7a3dff';
  const line = '#b98aff';
  const ticks = [-18, -9, 0, 9, 18];
  const rivets = [[x + c + 6, y + 6], [x2 - c - 6, y + 6], [x2 - 6, y2 - c - 6], [x + 6, y2 - c - 6]];

  return (
    <div style={{ position: 'absolute', top: -BLEED, left: -BLEED, width: W, height: H, pointerEvents: 'none' }}>
      <svg width={W} height={H} xmlns="http://www.w3.org/2000/svg">
        <path d={oct} fill="none" stroke={glow} strokeWidth={6} opacity={0.16} />
        <path d={oct} fill="none" stroke={line} strokeWidth={1.6} opacity={0.95} />
        <path d={octIn} fill="none" stroke={line} strokeWidth={0.8} opacity={0.35} />
        {ticks.map((o, idx) => (
          <line key={`t${idx}`} x1={x + w / 2 + o} y1={y} x2={x + w / 2 + o} y2={y - 4} stroke={line} strokeWidth={1.4} opacity={0.8} />
        ))}
        {ticks.map((o, idx) => (
          <line key={`b${idx}`} x1={x + w / 2 + o} y1={y2} x2={x + w / 2 + o} y2={y2 + 4} stroke={line} strokeWidth={1.4} opacity={0.8} />
        ))}
        {rivets.map(([cx, cy], idx) => (
          <circle key={idx} cx={cx} cy={cy} r={1.6} fill={line} opacity={0.85} />
        ))}
      </svg>
    </div>
  );
}
